import ScrollAnimation from 'react-animate-on-scroll';
import { ProjectIcon } from './ProjectIcon';
import { LinkIcon } from './LinkIcon';
import { FolderIcon } from './FolderIcon';
import type { ProjectData } from './projectsData';

interface ProjectCardProps {
  project: ProjectData;
}

export function ProjectCard({ project }: ProjectCardProps) {
  return (
    <ScrollAnimation animateIn="flipInX">
      <div className="project">
        <header>
          {project.icon ? (
            <ProjectIcon type={project.icon} size={50} />
          ) : (
            <FolderIcon size={50} />
          )}
          <div className="project-links">
            {project.links.map((link, index) => (
              <a
                key={index}
                href={link.href}
                target="_blank"
                rel="noreferrer"
                aria-label={`${project.title} — ${link.type}`}
              >
                <LinkIcon type={link.type} size={24} />
              </a>
            ))}
          </div>
        </header>
        <div className="body">
          <h3>{project.title}</h3>
          <p>{project.description}</p>
        </div>
        <footer>
          <ul className="tech-list">
            {project.tech.map((tech) => (
              <li key={tech}>{tech}</li>
            ))}
          </ul>
        </footer>
      </div>
    </ScrollAnimation>
  );
}
